import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}))

export default useStyles
